export const resourcesWithTags = [
  {
    title: "Should I Run Plain Docker Compose in Production in 2026?",
    url: "https://web.archive.org/web/20260606194317/https://distr.sh/blog/running-docker-in-production/",
    reference: "Yes, plain Docker Compose can still run production workloads in 2026—if you close the operational gaps it leaves: cleanup, healing, image pinning, socket security, and updates.",
    tags: ["containers", "operations & reliability", "software engineering"],
    dateAdded: "06-06-2026",
  },
  {
    title: "Three Inverse Laws of AI",
    url: "https://web.archive.org/web/20260606194330/https://susam.net/inverse-laws-of-robotics.html",
    reference: "Humans must not anthropomorphise AI systems. Humans must not blindly trust the output of AI systems. Humans must remain fully responsible and accountable for consequences arising from the use of AI systems.",
    tags: ["ai & ml", "human factors"],
    dateAdded: "06-06-2026",
  },
  {
    title: "Why I Like Using Docker Compose in Production",
    url: "https://web.archive.org/web/20260606195823/https://nickjanetakis.com/blog/why-i-like-using-docker-compose-in-production#does-it-scale",
    reference: "Here's why I used Docker Compose in 2015 and still use it today to run a majority of the apps I build and deploy.",
    tags: ["containers", "operations & reliability"],
    dateAdded: "06-06-2026",
  },
  {
    title: "Alert-driven monitoring",
    url: "https://web.archive.org/web/20260606200123/https://simpleobservability.com/docs/alert-driven-monitoring",
    reference: "It feels productive to see rows of glowing charts and telemetry. They make for some cool office art when you put them on a giant TV on the wall. But nobody spends their day watching graphs. The real core of infrastructure monitoring isn't dashboards. It's the alerts.",
    tags: ["observability & debugging", "operations & reliability"],
    dateAdded: "06-06-2026",
  },
  {
    title: "Laws of UX",
    url: "https://web.archive.org/web/20260606200630/https://lawsofux.com/",
    reference: "Laws of UX is a collection of best practices that designers can consider when building user interfaces.",
    tags: ["design & ux", "human factors"],
    dateAdded: "06-06-2026",
  },
  {
    title: "The woes of sanitizing SVGs",
    url: "https://web.archive.org/web/20260606200639/https://muffin.ink/blog/scratch-svg-sanitization/",
    reference: "I think Scratch's approach to SVG sanitization is doomed. To explain, we have to take a trip through the history of SVG sanitization in Scratch to see how well it has worked so far.",
    tags: ["web & frontend", "security & cryptography"],
    dateAdded: "06-06-2026",
  },
  {
    title: "Open Design: The open-source Claude Design alternative",
    url: "https://github.com/nexu-io/open-design",
    reference: "The local-first, open-source Claude Design alternative.  🖥️ Native desktop app for macOS and Windows.  ⚡ 100+ skills · ✨ 150 brand-grade DESIGN.md systems · 📦 261 ready-to-use plugins.  🖼️ Generates web · desktop · mobile prototypes, live dashboards / artifacts, decks, images, video, plus HyperFrames motion graphics.",
    tags: ["design & ux", "ai & ml", "tools"],
    dateAdded: "06-06-2026",
  },
  {
    title: "Laws of Software Engineering",
    url: "https://web.archive.org/web/20260606201112/https://lawsofsoftwareengineering.com/",
    reference: "A collection of principles and patterns that shape software systems, teams, and decisions.",
    tags: ["software engineering", "learning resources"],
    dateAdded: "06-06-2026",
  },
  {
    title: "The Git Commands I Run Before Reading Any Code",
    url: "https://web.archive.org/web/20260606201154/https://piechowski.io/post/git-commands-before-reading-code/",
    reference: "Five git log commands that diagnose a new codebase before you open a single file: code churn hotspots, bus factor, bug clusters, and crisis patterns.",
    tags: ["software engineering", "observability & debugging"],
    dateAdded: "06-06-2026",
  },
  {
    title: "The Virtual OS Museum",
    url: "https://virtualosmuseum.org/",
    reference: "This is a virtual museum of operating systems (and standalone applications) running under emulation, implemented as a Linux VM for QEMU, VirtualBox, or UTM.",
    tags: ["history & computing", "systems & performance"],
    dateAdded: "06-06-2026",
  },
  {
    title: "Why we should get rid of average CPU utilization",
    url: "https://web.archive.org/web/20260606201309/https://www.theocharis.dev/blog/why-we-should-get-rid-of-average-cpu-utilization/",
    reference: "Every tool shows you average CPU utilization, but none of the tools help you interpret it. None of them tell you that CPU utilization isn't linear to how much capacity you have. They just show you a percentage. The jump from 80% to 81% CPU utilization adds roughly 20× more wait time than the jump from 10% to 11%. So even with 20% \"headroom\" at 80% utilization, latencies have already started climbing:",
    tags: ["systems & performance", "operations & reliability"],
    dateAdded: "06-06-2026",
  },
  {
    title: "Learnings from 100K Lines of Rust with AI",
    url: "https://web.archive.org/web/20260521071301/https://zfhuang99.github.io/rust/claude%20code/codex/contracts/spec-driven%20development/2025/12/01/rust-with-ai.html",
    reference: "Besides unprecedented productivity, I discovered several techniques that were instrumental. This post shares my most valuable learnings on: ensuring correctness with code contracts, applying lightweight spec-driven development, and pursuing aggressive performance optimization — plus my wish list for the future of AI-assisted coding.",
    tags: ["ai & ml", "programming languages", "software engineering"],
    dateAdded: "06-06-2026",
  },
  {
    title: "MicroGPT",
    url: "https://karpathy.github.io/2026/02/12/microgpt/",
    reference: "This is a brief guide to my new art project microgpt, a single file of 200 lines of pure Python with no dependencies that trains and inferences a GPT. This file contains the full algorithmic content of what is needed: dataset of documents, tokenizer, autograd engine, a GPT-2-like neural network architecture, the Adam optimizer, training loop, and inference loop. Everything else is just efficiency. I cannot simplify this any further.",
    tags: ["ai & ml", "programming languages", "learning resources"],
    dateAdded: "06-04-2026",
  },
  {
    title: "MicroGPT explained interactively",
    url: "https://web.archive.org/web/20260405123537/https://growingswe.com/blog/microgpt",
    reference: "Andrej Karpathy wrote a 200-line Python script that trains and runs a GPT from scratch, with no libraries or dependencies, just pure Python. The script contains the algorithm that powers LLMs like ChatGPT. Let's walk through it piece by piece and watch each part work. Andrej did a walkthrough on his blog, but here I take a more visual approach, tailored for beginners.",
    tags: ["ai & ml", "visualization", "learning resources"],
    dateAdded: "06-04-2026",
  },
  {
    title: "Algorithm Visualizer",
    url: "https://algorithm-visualizer.org/",
    reference: "Welcome to Algorithm Visualizer, an interactive online platform designed to bring algorithms to life through visualization. Whether you're a student, teacher, or professional, our platform provides an engaging way to explore and understand various algorithms.",
    tags: ["algorithms & theory", "visualization", "learning resources"],
    dateAdded: "06-04-2026",
  },
  {
    title: "There Is No Spoon",
    url: "https://github.com/dreddnafious/thereisnospoon",
    reference: "A machine learning primer built from first principles. Written for engineers who want to reason about ML systems the way they reason about software systems.",
    tags: ["ai & ml", "software engineering", "learning resources"],
    dateAdded: "06-04-2026",
  },
  {
    title: "A Visual Introduction to Machine Learning",
    url: "https://web.archive.org/web/20260406205941/https://r2d3.us/visual-intro-to-machine-learning-part-1/",
    reference: "In machine learning, computers apply statistical learning techniques to automatically identify patterns in data. These techniques can be used to make highly accurate predictions.",
    tags: ["ai & ml", "visualization", "learning resources"],
    dateAdded: "06-04-2026",
  },
  {
    title: "The International Obfuscated C Code Contest: 2019/diels-grabsch2",
    url: "https://web.archive.org/web/20260317155821/https://www.ioccc.org/2019/diels-grabsch2/",
    reference: "IThis program prints its own SHA-512 hash.",
    tags: ["programming languages", "security & cryptography", "algorithms & theory"],
    dateAdded: "06-04-2026",
  },
  {
    title: "SaaS map of Brazil",
    url: "https://saas-map.ssr.trapiche.cloud/",
    reference: "Interactive map of SaaS by state and city.",
    tags: ["business & product", "tools"],
    dateAdded: "25-02-2026",
  },
  {
    title: "AI is Killing B2B SaaS",
    url: "https://web.archive.org/web/20260225030751/https://nmn.gl/blog/ai-killing-b2b-saas/",
    reference: "SaaS is the most profitable business model on Earth. It's easy to understand why: build once, sell the same thing again ad infinitum, and don't suffer any marginal costs on more sales. AI is bringing an existential threat to a lot of B2B SaaS executives: How to keep asking customers for renewal, when every customer feels they can get something better built with vibe-coded AI products?",
    tags: ["ai & ml", "business & product"],
    dateAdded: "25-02-2026",
  },
  {
    title: "My AI Adoption Journey",
    url: "https://web.archive.org/web/20260225030811/https://mitchellh.com/writing/my-ai-adoption-journey/",
    reference: "My experience adopting any meaningful tool is that I've necessarily gone through three phases: (1) a period of inefficiency (2) a period of adequacy, then finally (3) a period of workflow and life-altering discovery.",
    tags: ["ai & ml", "career & work", "developer workflow"],
    dateAdded: "25-02-2026",
  },
  {
    title: "Understanding Neural Networks, Visually",
    url: "https://web.archive.org/web/20260223120340/https://visualrambling.space/neural-network/",
    reference: "Interactive visualization of neural networks.",
    tags: ["ai & ml", "visualization", "learning resources"],
    dateAdded: "25-02-2026",
  },
  {
    title: "SectorC: A C Compiler in 512 bytes",
    url: "https://web.archive.org/web/20260224103155/https://xorvoid.com/sectorc.html",
    reference: "SectorC is a C compiler written in x86-16 assembly that fits within the 512 byte boot sector of an x86 machine. It supports a subset of C that is large enough to write real and interesting programs. It is quite likely the smallest C compiler ever written.",
    tags: ["systems & performance", "programming languages"],
    dateAdded: "25-02-2026",
  },
  {
    title: "Cosmologically Unique IDs",
    url: "https://web.archive.org/web/20260225031433/https://jasonfantl.com/posts/Universal-Unique-IDs/",
    reference: "Or maybe we convert all of the mass of the universe into 1-gram nanobots? We would have 1.5 x 10^{56} bots, which would require IDs of 372 bits.",
    tags: ["identity & privacy", "algorithms & theory"],
    dateAdded: "25-02-2026",
  },
  {
    title: "The Age-Verification Trap: Verifying user's ages undermines everyone's data protection",
    url: "https://web.archive.org/web/20260225031838/https://spectrum.ieee.org/age-verification/",
    reference: "Social media is going the way of alcohol, gambling, and other social sins: Societies are deciding it's no longer kid stuff. Lawmakers point to compulsive use, exposure to harmful content, and mounting concerns about adolescent mental health. So, many propose to set a minimum age, usually 13 or 16.",
    tags: ["identity & privacy", "security & cryptography", "human factors"],
    dateAdded: "25-02-2026",
  },
  {
    title: "The cryptography behind electronic passports",
    url: "https://web.archive.org/web/20260225032126/https://blog.trailofbits.com/2025/10/31/the-cryptography-behind-electronic-passports/",
    reference: "Did you know that most modern passports are actually embedded devices containing an entire filesystem, access controls, and support for several cryptographic protocols?",
    tags: ["identity & privacy", "security & cryptography"],
    dateAdded: "25-02-2026",
  },
  {
    title: "Replacing JS with just HTML",
    url: "https://web.archive.org/web/20260222185103/https://www.htmhell.dev/adventcalendar/2025/27/",
    reference: "As time marches on, and the HTML and CSS methods gain traction, we need to start replacing the old JS methods that feel so comfy with new methods that require less JS.",
    tags: ["web & frontend", "software engineering"],
    dateAdded: "25-02-2026",
  },
  {
    title: "Clock Synchronization Is a Nightmare",
    url: "https://web.archive.org/web/20260201062201/https://arpitbhayani.me/blogs/clock-sync-nightmare",
    reference: "Time seems simple. But we engineers lose sleep over something as basic as keeping clocks in sync. Here's why...",
    tags: ["distributed systems & time", "systems & performance"],
    dateAdded: "25-02-2026",
  },
  {
    title: "Unconventional PostgreSQL Optimizations",
    url: "https://web.archive.org/web/20260225032714/https://hakibenita.com/postgresql-unconventional-optimizations",
    reference: "When it comes to database optimization, developers often reach for the same old tools: rewrite the query slightly differently, slap an index on a column, denormalize, analyze, vacuum, cluster, repeat. Conventional techniques are effective, but sometimes being creative can really pay off!",
    tags: ["systems & performance", "software engineering"],
    dateAdded: "25-02-2026",
  },
  {
    title: "21 Lessons From 14 Years at Google",
    url: "https://web.archive.org/web/20260225032655/https://addyosmani.com/blog/21-lessons/",
    reference: "When I joined Google ~14 years ago, I thought the job was about writing great code. I was partly right. But the longer I've stayed, the more I've realized that the engineers who thrive aren't necessarily the best programmers - they're the ones who've figured out how to navigate everything around the code: the people, the politics, the alignment, the ambiguity.",
    tags: ["career & work", "software engineering"],
    dateAdded: "25-02-2026",
  },
  {
    title: "Python Numbers Every Programmer Should Know",
    url: "https://web.archive.org/web/20260221152954/https://mkennedy.codes/posts/python-numbers-every-programmer-should-know/",
    reference: "There are numbers every Python programmer should know. For example, how fast or slow is it to add an item to a list in Python? What about opening a file? Is that less than a millisecond? Is there something that makes that slower than you might have guessed? If you have a performance sensitive algorithm, which data structure should you use? How much memory does a floating point number use? What about a single character or the empty string? How fast is FastAPI compared to Django?",
    tags: ["programming languages", "systems & performance"],
    dateAdded: "25-02-2026",
  },
  {
    title: "HTTP caching, a refresher",
    url: "https://web.archive.org/web/20251223210918/https://danburzo.ro/http-caching-refresher",
    reference: "This is a reading of RFC 9111 (2022), the latest iteration of the HTTP Caching standard. It defines the Cache-Control HTTP header as a way to prescribe how caches should store and reuse HTTP responses, with regards to not just the browser cache, but to any other intermediary caches, such as proxies and content delivery networks, that may exist between the client and the origin server.",
    tags: ["web & frontend", "networks & protocols"],
    dateAdded: "26-12-2025",
  },
  {
    title: "A 1961 Relay Computer Running in Your Browser",
    url: "https://minivac.greg.technology",
    reference: "Before microchips existed, computers were built with mechanical relays. This is a working simulation of the Minivac 601, an educational computer designed by Claude Shannon. You can watch it think slowly enough to see every step.",
    tags: ["history & computing", "systems & performance", "visualization"],
    dateAdded: "26-12-2025",
  },
  {
    title: "You're Not Burnt Out. You're Existentially Starving.",
    url: "https://web.archive.org/web/20251223151150/https://neilthanedar.com/youre-not-burnt-out-youre-existentially-starving/",
    reference: "Let me guess: Your life is going pretty darn well by any objective metric. Nice place to live. More than enough stuff. Family and friends who love you. But you're tired, burnt out, and more. It feels like you're stuck in the ordinary when all you want to do is chase greatness.",
    tags: ["career & work", "human factors"],
    dateAdded: "26-12-2025",
  },
  {
    title: "You Don't Need to Spend $100/mo on Claude Code: Your Guide to Local Coding Models",
    url: "https://web.archive.org/web/20251226161149/https://www.aiforswes.com/p/you-dont-need-to-spend-100mo-on-claude",
    reference: "What you need to know about local model tooling and the steps for setting one up yourself",
    tags: ["ai & ml", "developer workflow", "tools"],
    dateAdded: "26-12-2025",
  },
  {
    title: "WalletWallet: A simple utility to convert physical barcodes into digital passes for Apple Wallet®.",
    url: "https://walletwallet.alen.ro/",
    reference: "A simple utility to convert physical barcodes into digital passes for Apple Wallet®. Entirely free and runs directly from your browser. 1 Enter your membership or loyalty card barcode data. 2 Configure the appearance and titles for your pass. 3 Download and open the file to add it to your Wallet.",
    tags: ["identity & privacy", "tools"],
    dateAdded: "26-12-2025",
  },
  {
    title: "Great Ideas in Theoretical Computer Science",
    url: "https://www.cs251.com/",
    reference: "Welcome to CS251 at CMU! This course is about the rigorous study of computation, which is a fundamental component of our universe, the societies we live in, the new technologies we discover, as well as the minds we use to understand these things.",
    tags: ["algorithms & theory", "learning resources"],
    dateAdded: "26-12-2025",
  },
  {
    title: "A Safer Container Ecosystem with Docker: Free Docker Hardened Images",
    url: "https://web.archive.org/web/20251218055553/https://www.docker.com/blog/docker-hardened-images-for-every-developer/",
    reference: "Docker Hub has over 20 billion monthly pulls, with nearly 90% of organizations now relying on containers in their software delivery workflows. That gives us a responsibility: to help secure the software supply chain for the world.",
    tags: ["containers", "security & cryptography"],
    dateAdded: "26-12-2025",
  },
  {
    title: "If You're Going to Vibe Code, Why Not Do It in C?",
    url: "https://web.archive.org/web/20251214000332/https://stephenramsay.net/posts/vibe-coding.html",
    reference: "Why vibe code with a language that has human convenience and ergonomics in view? Or to put that another way: Wouldn't a language designed for vibe coding naturally dispense with much of what is convenient and ergonomic for humans in favor of what is convenient and ergonomic for machines? Why not have it just write C? Or hell, why not x86 assembly?",
    tags: ["ai & ml", "programming languages"],
    dateAdded: "26-12-2025",
  },
  {
    title: "Constructing The World's First JPEG XL MD5 Hash Quine",
    url: "https://web.archive.org/web/20251209151610/https://stackchk.fail/blog/jxl_hashquine_writeup",
    reference: "You may have heard the term Quine before… It means a program which prints its own source.",
    tags: ["security & cryptography", "algorithms & theory"],
    dateAdded: "26-12-2025",
  },
  {
    title: "Big O",
    url: "https://web.archive.org/web/20250909191613/https://samwho.dev/big-o/",
    reference: "Big O notation is a way of describing the performance of a function without using time. Rather than timing a function from start to finish, big O describes how the time grows as the input size increases. It is used to help understand how programs will perform across a range of inputs.",
    tags: ["algorithms & theory", "learning resources"],
    dateAdded: "12-09-2025",
  },
  {
    title: "Everything I know about good API design",
    url: "https://web.archive.org/web/20250912155311/https://www.seangoedecke.com/good-api-design/",
    reference: "Like designing good software systems, I think much of the advice floating around about API design is too fancy. People get wrapped up in what “real” REST is, or whether HATEOAS is a good idea, and so on. This post is my attempt at writing down everything I know about designing good APIs.",
    tags: ["software engineering", "web & frontend"],
    dateAdded: "12-09-2025",
  },
  {
    title: "What Is the Fourier Transform?",
    url: "https://web.archive.org/web/20250912155305/https://www.quantamagazine.org/what-is-the-fourier-transform-20250903/",
    reference: "Amid the chaos of revolutionary France, one man's mathematical obsession gave way to a calculation that now underpins much of mathematics and physics. The calculation, called the Fourier transform, decomposes any function into its parts.",
    tags: ["math", "algorithms & theory"],
    dateAdded: "12-09-2025",
  },
  {
    title: "Passkeys and Modern Authentication",
    url: "https://web.archive.org/web/20250909100019/https://lucumr.pocoo.org/2025/9/2/passkeys/",
    reference: "There is an ongoing trend in the industry to move people away from username and password towards passkeys. The intentions here are good, and I would assume that this has a significant net benefit for the average consumer. At the same time, the underlying standard has some peculiarities. These enable behaviors by large corporations, employers, and governments that are worth thinking about.",
    tags: ["identity & privacy", "security & cryptography"],
    dateAdded: "12-09-2025",
  },
  {
    title: "Experimenting with local LLMs on macOS",
    url: "https://web.archive.org/web/20250912155926/https://blog.6nok.org/experimenting-with-local-llms-on-macos/",
    reference: "So, this blog post will be about LLMs, and everyone has opinions about that. To be upfront about it, I'm a skeptic, yet I like experimenting with stuff so I download and run them locally on my Mac. And I'll teach you how to do it too, if you'd like!",
    tags: ["ai & ml", "tools"],
    dateAdded: "12-09-2025",
  },
  {
    title: "The maths you need to start understanding LLMs",
    url: "https://web.archive.org/web/20250912155944/https://www.gilesthomas.com/2025/09/maths-for-llms",
    reference: "This article is the second of three \"state of play\" posts that explain how Large Language Models work, aimed at readers with the level of understanding I had in mid-2022: techies with no deep AI knowledge.",
    tags: ["ai & ml", "math"],
    dateAdded: "12-09-2025",
  },
  {
    title: "The Prompt Engineering Playbook for Programmers: Turn AI coding assistants into more reliable development partners",
    url: "https://web.archive.org/web/20250610201612/https://addyo.substack.com/p/the-prompt-engineering-playbook-for",
    reference: "Developers are increasingly relying on AI coding assistants to accelerate our daily workflows. These tools can autocomplete functions, suggest bug fixes, and even generate entire modules or MVPs. Yet, as many of us have learned, the quality of the AI's output depends largely on the quality of the prompt you provide. In other words, prompt engineering has become an essential skill.",
    tags: ["ai & ml", "developer workflow"],
    dateAdded: "12-09-2025",
  },
  {
    title: "Reinvent the Wheel",
    url: "https://web.archive.org/web/20250610201557/https://endler.dev/2025/reinvent-the-wheel/",
    reference: "One of the most harmful pieces of advice is to not reinvent the wheel. It usually comes from a good place, but is typically given by two groups of people: those who tried to invent a wheel themselves and know how hard it is; those who never tried to invent a wheel and blindly follow the advice.",
    tags: ["software engineering", "learning resources"],
    dateAdded: "10-06-2025",
  },
  {
    title: "My favourite fonts to use with LaTeX",
    url: "https://web.archive.org/web/20250610201505/https://www.lfe.pt/latex/fonts/typography/2022/11/21/latex-fonts-part1.html",
    reference: "TeX and related systems are often associated with their default fonts, Donald Knuth's Computer Modern (CM) typefaces. While these fonts are excellent, they have become so ubiquitous in the scientific community that many LaTeX users have sought alternative fonts for their documents. As a result, a plethora of font packages and even OpenType-compatible engines (XeLaTeX and LuaLaTeX) have emerged in the past 20 years.",
    tags: ["research & writing", "design & ux"],
    dateAdded: "10-06-2025",
  },
  {
    title: "Open Source Society University: Path to a free self-taught education in Computer Science",
    url: "https://github.com/ossu/computer-science/",
    reference: "The OSSU curriculum is a complete education in computer science using online materials. It's not merely for career training or professional development. It's for those who want a proper, well-rounded grounding in concepts fundamental to all computing disciplines, and for those who have the discipline, will, and (most importantly!) good habits to obtain this education largely on their own, but with support from a worldwide community of fellow learners.",
    tags: ["learning resources", "algorithms & theory"],
    dateAdded: "10-06-2025",
  },
  {
    title: "Millions of Accounts Vulnerable due to Google's OAuth Flaw",
    url: "https://web.archive.org/web/20250214231149/https://trufflesecurity.com/blog/millions-at-risk-due-to-google-s-oauth-flaw/",
    reference: "Millions of Americans can have their data stolen right now because of a deficiency in Google's “Sign in with Google” authentication flow. If you've worked for a startup in the past - especially one that has since shut down - you might be vulnerable.",
    tags: ["identity & privacy", "security & cryptography"],
    dateAdded: "28-02-2025",
  },
  {
    title: "Build It Yourself",
    url: "https://web.archive.org/web/20250209131536/https://lucumr.pocoo.org/2025/1/24/build-it-yourself/",
    reference: "You're probably familiar with the concept of 'dependency churn.' It's that never-ending treadmill of updates, patches, audits, and transitive dependencies that we as developers love to casually install in the name of productivity.",
    tags: ["software engineering", "developer workflow"],
    dateAdded: "28-02-2025",
  },
  {
    title: "Hell Is Overconfident Developers Writing Encryption Code",
    url: "https://web.archive.org/web/20250219162025/https://soatok.blog/2025/01/31/hell-is-overconfident-developers-writing-encryption-code/",
    reference: "Overconfident developers that choose to write their own cryptography code have plagued the information security industry since before it was even an industry.",
    tags: ["security & cryptography", "software engineering"],
    dateAdded: "28-02-2025",
  },
  {
    title: "httptap",
    url: "https://github.com/monasticacademy/httptap",
    reference: "View the HTTP and HTTPS requests made by any linux program.",
    tags: ["networks & protocols", "observability & debugging", "tools"],
    dateAdded: "28-02-2025",
  },
  {
    title: "Developer philosophy",
    url: "https://web.archive.org/web/20250220224501/https://qntm.org/devphilo",
    reference: "A few weeks ago at work we had a talk where senior developers (including me) were invited to spend around five minutes each talking about our personal software development philosophies. The idea was for us to share our years of experience with our more junior developers.",
    tags: ["career & work", "software engineering"],
    dateAdded: "28-02-2025",
  },
  {
    title: "How Core Git Developers Configure Git",
    url: "https://web.archive.org/web/20250228151635/https://blog.gitbutler.com/how-git-core-devs-configure-git/",
    reference: "What git config settings should be defaults by now? Here are some settings that even the core developers change.",
    tags: ["developer workflow", "software engineering"],
    dateAdded: "28-02-2025",
  },
  {
    title: "Ask for no, don't ask for yes",
    url: "https://web.archive.org/web/20250227050237/https://www.mooreds.com/wordpress/archives/3518",
    reference: "One habit I like is to ask for no, not yes.",
    tags: ["business & product", "career & work"],
    dateAdded: "28-02-2025",
  },
  {
    title: "Subtrace: Wireshark for Docker containers",
    url: "https://github.com/subtrace/subtrace",
    reference: "Subtrace is Wireshark for your Docker containers. It lets developers see all incoming and outgoing requests in their backend server so that they can resolve production issues faster.",
    tags: ["containers", "networks & protocols", "observability & debugging"],
    dateAdded: "28-02-2025",
  },
  {
    title: "A year of uv: pros, cons, and should you migrate",
    url: "https://web.archive.org/web/20250227114054/https://www.bitecode.dev/p/a-year-of-uv-pros-cons-and-should",
    reference: "After one year of trying uv, the new Python project management tool by Astral, with many clients, I have seen what it's good and bad for. My conclusion is: if your situation allows it, always try uv first. Then fall back on something else if that doesn't work out.",
    tags: ["programming languages", "developer workflow", "tools"],
    dateAdded: "28-02-2025",
  },
  {
    title: "A calculator app? Anyone could make that.",
    url: "https://chadnauseam.com/coding/random/calculator-app/",
    reference: "A calculator should show you the result of the mathematical expression you entered. That's much, much harder than it sounds. What I'm about to tell you is the greatest calculator app development story ever told.",
    tags: ["algorithms & theory", "programming languages", "software engineering"],
    dateAdded: "28-02-2025",
  },
  {
    title: "Nping",
    url: "https://github.com/hanshuaikang/Nping/",
    reference: "Nping is a Ping tool developed in Rust. It supports concurrent Ping for multiple addresses, visual chart display, real-time data updates, and other features.",
    tags: ["networks & protocols", "observability & debugging", "tools"],
    dateAdded: "28-02-2025",
  },
  {
    title: "MapTCHA, the open source CAPTCHA that improves OpenStreetMap",
    url: "https://fosdem.org/2025/schedule/event/fosdem-2025-5879-maptcha-the-open-source-captcha-that-improves-openstreetmap/",
    reference: "OpenStreetMap (OSM) has many objects remaining to be mapped, but the quality of AI-generated objects is not high enough for direct inclusion. We introduce MapTCHA, a CAPTCHA that leverages the uncertainty of interpreting imagery with computer vision, and provides human verification for AI predictions: users are asked to identify images containing correctly interpreted objects, e.g. building outlines.",
    tags: ["security & cryptography", "ai & ml", "tools"],
    dateAdded: "28-02-2025",
  },
  {
    title: "The First Six Books of The Elements of Euclid With Coloured Diagrams and Symbols",
    url: "https://www.c82.net/euclid/",
    reference: "A reproduction of Oliver Byrne's celebrated work from 1847 plus interactive diagrams, cross references, and posters designed by Nicholas Rougeux.",
    tags: ["math", "visualization", "history & computing"],
    dateAdded: "28-02-2025",
  },
  {
    title: "I am (not) a Failure: Lessons Learned From Six (and a half) Failed Startup Attempts",
    url: "https://web.archive.org/web/20250218140111/https://blog.rongarret.info/2025/01/i-am-not-failure-lessons-learned-from.html/",
    reference: "If my younger self had heard these stories he might have had a less stressful life knowing that even a long string of failures in specific endeavors doesn't necessarily translate to failure in life.  Maybe some version of my younger self is still out there and will get some similar value out of it.",
    tags: ["business & product", "career & work"],
    dateAdded: "28-02-2025",
  },
  {
    title: "On the nature of Computing Science",
    url: "https://web.archive.org/save/https://www.cs.utexas.edu/~EWD/transcriptions/EWD08xx/EWD896.html",
    reference: "We all know, how computing is now expected to cure all ills of the world and more, and how as far as these expectations are concerned, even the sky is no longer accepted as the limit.",
    tags: ["algorithms & theory", "history & computing"],
    dateAdded: "14-01-2025",
  },
  {
    title: "Operating System in 1,000 Lines",
    url: "https://operating-system-in-1000-lines.vercel.app/en/",
    reference: "We're going to build a small operating system from scratch, step by step.",
    tags: ["systems & performance", "programming languages", "learning resources"],
    dateAdded: "14-01-2025",
  },
  {
    title: "Semantic Reader: An AI-Powered Augmented Scientific Reading Application",
    url: "https://www.semanticscholar.org/product/semantic-reader/",
    reference: "Semantic Reader is an augmented reader with the potential to revolutionize scientific reading by making it more accessible and richly contextual.",
    tags: ["research & writing", "ai & ml", "tools"],
    dateAdded: "14-01-2025",
  },
  {
    title: "mCaptcha",
    url: "https://mcaptcha.org/",
    reference: "mCaptcha is proof-of-work based captcha system that is privacy focused and fully automated.",
    tags: ["security & cryptography", "tools"],
    dateAdded: "14-01-2025",
  },
  {
    title: "Nearly All Binary Searches and Mergesorts are Broken",
    url: "https://research.google/blog/extra-extra-read-all-about-it-nearly-all-binary-searches-and-mergesorts-are-broken/",
    reference: "And now we know the binary search is bug-free, right? Well, we strongly suspect so, but we don't know. It is not sufficient merely to prove a program correct; you have to test it too. Moreover, to be really certain that a program is correct, you have to test it for all possible input values, but this is seldom feasible.",
    tags: ["algorithms & theory", "programming languages"],
    dateAdded: "14-01-2025",
  },
  {
    title: "Falsehoods Programmers Believe About Names",
    url: "https://web.archive.org/web/20250102003939/https://www.kalzumeus.com/2010/06/17/falsehoods-programmers-believe-about-names/",
    reference: "I have never seen a computer system which handles names properly and doubt one exists, anywhere.",
    tags: ["identity & privacy", "human factors", "software engineering"],
    dateAdded: "04-01-2025",
  },
  {
    title: "Falsehoods programmers believe about time",
    url: "https://web.archive.org/web/20250102173731/https://infiniteundo.com/post/25326999628/falsehoods-programmers-believe-about-time",
    reference: "That thing about a minute being longer than an hour was a joke, right? No.",
    tags: ["distributed systems & time", "software engineering"],
    dateAdded: "04-01-2025",
  },
  {
    title: "Seconds Since the Epoch",
    url: "https://web.archive.org/web/20250101185009/https://aphyr.com/posts/378-seconds-since-the-epoch",
    reference: "Consequently, every few years POSIX time jumps backwards, wreaking utter havoc. Someday it might jump forward.",
    tags: ["distributed systems & time", "systems & performance"],
    dateAdded: "04-01-2025",
  },
  {
    title: "Salary Negotiation: Make More Money, Be More Valued",
    url: "https://web.archive.org/web/20250102183302/https://www.kalzumeus.com/2012/01/23/salary-negotiation/",
    reference: "Your salary negotiation — which routinely takes less than 5 minutes to conclude — has an outsized influence on what your compensation is.",
    tags: ["career & work", "business & product"],
    dateAdded: "05-01-2025",
  },
  {
    title: "Developer Roadmaps",
    url: "https://roadmap.sh/",
    reference: "roadmap.sh is a community effort to create roadmaps, guides and other educational content to help guide developers in picking up a path and guide their learnings.",
    tags: ["learning resources", "developer workflow"],
    dateAdded: "05-01-2025",
  },
  {
    title: "Writing scientific articles like a native English speaker: top ten tips for Portuguese speakers",
    url: "https://www.scielo.br/j/clin/a/zcs47Q4bsW6yk7D86XQCVss/",
    reference: "I decided to assemble a compilation of the 10 most common errors made by native Portuguese speakers when writing scientific papers in English.",
    tags: ["research & writing", "learning resources"],
    dateAdded: "05-01-2025",
  }
];
  
